import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';

import { Outer, TitleWrapper, StyledTitle, ActionsWrapper, BottomBarWrapper, BreadcrumbsContainer, TitleContainer } from './styled';

var PageHeader = function (_Component) {
  _inherits(PageHeader, _Component);

  function PageHeader() {
    _classCallCheck(this, PageHeader);

    return _possibleConstructorReturn(this, (PageHeader.__proto__ || _Object$getPrototypeOf(PageHeader)).apply(this, arguments));
  }

  _createClass(PageHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          breadcrumbs = _props.breadcrumbs,
          actions = _props.actions,
          bottomBar = _props.bottomBar,
          children = _props.children,
          disableTitleStyles = _props.disableTitleStyles,
          truncateTitle = _props.truncateTitle;

      return React.createElement(
        Outer,
        null,
        breadcrumbs && React.createElement(
          BreadcrumbsContainer,
          null,
          ' ',
          breadcrumbs,
          ' '
        ),
        React.createElement(
          TitleWrapper,
          null,
          React.createElement(
            TitleContainer,
            null,
            disableTitleStyles ? children : React.createElement(
              StyledTitle,
              { truncate: truncateTitle },
              children
            )
          ),
          React.createElement(
            ActionsWrapper,
            null,
            actions
          )
        ),
        bottomBar && React.createElement(
          BottomBarWrapper,
          null,
          ' ',
          bottomBar,
          ' '
        )
      );
    }
  }]);

  return PageHeader;
}(Component);

PageHeader.defaultProps = {
  disableTitleStyles: false,
  truncateTitle: false
};
export default PageHeader;